<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<Button type="primary" @click="add" v-if="addTrue">新增</Button>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)" v-show="row.macContractState=='LRZ' || row.macContractState=='QRZ' ">修改</Button>
				
				
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading:false,
				total:100,
				addTrue:false,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '订单编号',
						key: 'contractCode'
					},
					{
						title: '设备编号',
						key: 'macDetailsCode'
					},
					{
						title: '设备名称',
						key: 'macDetailsName'
					},
					{
						title: '分类',
						key: 'macKindString'
					},
					{
						title: '单价',
						key: 'unitPrice',
						render: (h, params) => {
						    return h("div",params.row.unitPrice/100)
						}
					},
					{
						title: '设备数量',
						key: 'number'
						
					},
					{
						title: '已安装数量',
						key: 'installNumber'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10,
					orderId:''
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/platform/macOrder/details/update',
					query:{
						id:id
					}
				})
			},
			add() {
				this.$router.push({
					name: 'jm/platform/macOrder/details/add',
					query:{
						orderId:this.query.orderId
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/contract/details/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
						if(_this.data6.length>0 ){
							if(_this.data6[0].macContractState=='LRZ' || _this.data6[0].macContractState=='QRZ'){
								_this.addTrue=true
							}
							
						}else{
							_this.addTrue=true
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page
	    },
		created(){
			this.query.orderId=this.$route.query.id
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/macOrder/details/list.vue